import OpeningTimes from './OpeningTimes';

export default class Dealer {
  /**
   * @type {OpeningTimes}
   */
  openingTimes = null;

  constructor(dealerData) {
    Object.assign(this, dealerData);
    this.openingTimes = new OpeningTimes(dealerData.openingTimes);
  }

  static getMainShopIdFromSubshopId(subshopId) {
    if (!subshopId) return false;

    const dashes = (subshopId.match(/-/g) || []).length;

    if (dashes < 2) return subshopId;

    const firstDashIndex = subshopId.indexOf('-');
    const secondDashIndex = subshopId.indexOf('-', firstDashIndex + 1);

    const mainShopId = subshopId.substring(0, secondDashIndex);

    return mainShopId;
  }

  static isSubshop(shopId) {
    return (shopId.match(/-/g) || []).length > 1;
  }

  static isMainshop(shopId) {
    return (shopId.match(/-/g) || []).length <= 1;
  }
}



// WEBPACK FOOTER //
// ./src/models/Dealer.js